/* global $ */

$(function () {
	$('body').on('product:afterAttributeSelect', function (e, response) {
		if (response.data.product.price.sales) {
			document
				.getElementsByTagName('klarna-placement')[0]
				.setAttribute(
					'data-purchase-amount',
					Math.round(response.data.product.price.sales.value * 100)
				);
			if (
				response.data.product.price.sales &&
				response.data.product.price.sales.value <= 10000 &&
				response.data.product.price.sales.value >= 35
			) {
				$('.js-klarna-osmpdp').removeClass('d-none');
			} else {
				$('.js-klarna-osmpdp').addClass('d-none');
			}
			window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
		}
	});
});
